export default __webpack_public_path__ + "static/media/google.82659b47.svg";